// Klient HTTP serwisu podcast-core (servers/podcast-core, patrz API_CONTRACT.md).
// Lokalnie: REACT_APP_PODCAST_API_URL (frontend/.env.development.local) albo http://localhost:4709.
// Produkcja: Apache proxy https://api.prosecaptain.com/podcasts/ -> podcast-core.

const PODCAST_REMOTE_BASE = 'https://api.prosecaptain.com/podcasts';
export const LOCAL_PODCAST_ORIGIN = process.env.REACT_APP_PODCAST_API_URL || 'http://localhost:4709';

export const getPodcastApiBase = () => {
  const isLocalhost = window.location.hostname === 'localhost';
  return (isLocalhost ? LOCAL_PODCAST_ORIGIN : PODCAST_REMOTE_BASE).replace(/\/+$/, '');
};

const getToken = () =>
  localStorage.getItem('directus_token') || sessionStorage.getItem('directus_token');

const request = async (path, { auth = true, ...options } = {}) => {
  const token = auth ? getToken() : null;
  const isForm = typeof FormData !== 'undefined' && options.body instanceof FormData;
  const headers = {
    Accept: 'application/json',
    // Dla FormData nie ustawiamy Content-Type - fetch sam doda boundary.
    ...(options.body && !isForm ? { 'Content-Type': 'application/json' } : {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(options.headers || {})
  };

  let response;
  try {
    response = await fetch(`${getPodcastApiBase()}${path}`, { ...options, headers });
  } catch (networkError) {
    const error = new Error('');
    error.code = 'network';
    error.cause = networkError;
    throw error;
  }

  let data = null;
  try {
    data = await response.json();
  } catch (parseError) {
    data = null;
  }

  if (!response.ok) {
    const error = new Error((data && data.error) || '');
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
};

/**
 * Tworzy zadanie. payload: { url | text (+title) | file, language, tone, seconds, hostA, hostB }.
 * Plik -> multipart/form-data (pole `file`), w przeciwnym razie JSON.
 */
export const createPodcast = (payload) => {
  const { file, ...fields } = payload || {};
  if (file) {
    const form = new FormData();
    form.append('file', file, file.name);
    Object.entries(fields).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') form.append(key, String(value));
    });
    return request('/api/podcasts', { method: 'POST', body: form });
  }
  return request('/api/podcasts', { method: 'POST', body: JSON.stringify(fields) });
};

export const getPodcast = (id) => request(`/api/podcasts/${encodeURIComponent(id)}`);

export const listPodcasts = async () => {
  const data = await request('/api/podcasts');
  return Array.isArray(data?.items) ? data.items : [];
};

// Publiczny config kreatora (języki, tony, długości, prowadzący) - bez autoryzacji.
export const getPodcastConfig = () => request('/api/public/config', { auth: false });

// Adres zasobu serwowanego przez podcast-core (względny do bazy API).
export const podcastAssetUrl = (path) => {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  return `${getPodcastApiBase()}${path.startsWith('/') ? '' : '/'}${path}`;
};

export const audioSrc = (job) => podcastAssetUrl(job?.audioUrl);

// Same file with Content-Disposition: attachment (podcast-core ?download=1), so the browser saves
// it even cross-origin, where the `download` attribute is ignored.
export const audioDownloadSrc = (job) => {
  const src = audioSrc(job);
  if (!src) return null;
  return `${src}${src.includes('?') ? '&' : '?'}download=1`;
};

export const hostAvatarUrl = (hostId) => podcastAssetUrl(`hosts/avatars/${hostId}-256.webp`);

// Czytelny komunikat błędu API (serwer zwraca { error } po polsku).
export const describePodcastError = (error, t) => {
  if (!error) return t('podcasts.errors.generic');
  if (error.code === 'network') return t('podcasts.errors.network');
  if (error.status === 401) return t('podcasts.errors.unauthorized');
  if (error.status === 429) return error.message || t('podcasts.errors.rateLimit');
  if (error.status === 404) return error.message || t('podcasts.errors.notFound');
  return error.message || t('podcasts.errors.generic');
};
